const SuppressedCountTabBadgeTestIdsScope = {
  SUPPRESSED_COUNT_BADGE: 'suppressed-count-badge',
};

export const SuppressedCountTabBadgeTestIds = {
  BADGE_BUTTON: `${SuppressedCountTabBadgeTestIdsScope.SUPPRESSED_COUNT_BADGE}.badge-button`,
};
